import React from 'react'
import { CrossChainTransaction } from 'state/cross-swap-transactions/types'
import CrossChainSwap from './CrossChainSwap'

const CrossChainTransaction: React.FC<{ transaction: CrossChainTransaction }> = ({ transaction, ...props }) => {
  return <CrossChainSwap transaction={transaction} {...props} />
}

export default CrossChainTransaction
